import "./bootstrap";
import "./jquery";
import "./axios";
import "./swiper";
import "./typed";
import "./accounting";
import "./nouislider";
import "./lozad";
import "./leaflet";
import "./wnumb";
import "./aos";
import "./plyr";
import "./tom-select";
import "./utm";
import "./screensaver";

// ?noscript=true spegne tutte le terze parti, chat compresa (vedi head.blade.php)
const terzePartiSpente = new URLSearchParams(window.location.search).get("noscript") === "true";

if (import.meta.env.PROD && !terzePartiSpente) {
    import('./ekonsilio').then(({ initEkonsilioChat, onUserInteract, observerUserChat }) => {
        observerUserChat();
    });
}
// if (import.meta.env.PROD) {
// import("./lenis");
// }
import "./import-custom-modules";
import "./myscripts"; // myscripts sempre alla fine
